import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { template, section } from "../app/schema";

export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_ERROR = "GET_TEMPLATES_ERROR";

export const GET_TEMPLATE = "GET_TEMPLATE";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";
export const GET_TEMPLATE_ERROR = "GET_TEMPLATE_ERROR";

export const POST_TEMPLATES = "POST_TEMPLATES";
export const POST_TEMPLATES_SUCCESS = "POST_TEMPLATES_SUCCESS";
export const POST_TEMPLATES_ERROR = "POST_TEMPLATES_ERROR";

export const PATCH_TEMPLATE = "PATCH_TEMPLATE";
export const PATCH_TEMPLATE_SUCCESS = "PATCH_TEMPLATE_SUCCESS";
export const PATCH_TEMPLATE_ERROR = "PATCH_TEMPLATE_ERROR";

export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_ERROR = "DELETE_TEMPLATE_ERROR";

export const GET_TEMPLATE_SECTIONS = "GET_TEMPLATE_SECTIONS";
export const GET_TEMPLATE_SECTIONS_SUCCESS = "GET_TEMPLATE_SECTIONS_SUCCESS";
export const GET_TEMPLATE_SECTIONS_ERROR = "GET_TEMPLATE_SECTIONS_ERROR";

export const POST_TEMPLATE_SECTIONS = "POST_TEMPLATE_SECTIONS";
export const POST_TEMPLATE_SECTIONS_SUCCESS = "POST_TEMPLATE_SECTIONS_SUCCESS";
export const POST_TEMPLATE_SECTIONS_ERROR = "POST_TEMPLATE_SECTIONS_ERROR";

export const SET_IS_ADD_SECTION_MODAL_VISIBLE = "SET_IS_ADD_SECTION_MODAL_VISIBLE";
export const SET_IS_ADD_TEMPLATE_MODAL_VISIBLE = "SET_IS_ADD_TEMPLATE_MODAL_VISIBLE";
export const SET_IS_EDIT_TEMPLATE_MODAL_VISIBLE = "SET_IS_EDIT_TEMPLATE_MODAL_VISIBLE";
export const SET_IS_REMOVE_TEMPLATE_MODAL_VISIBLE = "SET_IS_REMOVE_TEMPLATE_MODAL_VISIBLE";

// Validation
const validateForm = {
  createTemplate: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createTemplateSection: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests
const getTemplatesGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/templates?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getTemplateGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/templates/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postTemplates = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/templates`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchTemplate = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/templates/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteTemplate = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/templates/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych szablonu, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getTemplateSectionsGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/templates/${uid}/sections`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postTemplateSections = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/templates/${uid}/sections`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions
export function getTemplates(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_TEMPLATES],
    payload: {
      promise: getTemplatesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { templates: arrayOf(template) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getTemplate(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_TEMPLATE],
    payload: {
      promise: getTemplateGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, template);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        uid
      }
    }
  });
}

export function createTemplate(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_TEMPLATES],
    payload: {
      promise: validateForm
        ["createTemplate"](validate, data)
        .then(() =>
          postTemplates(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, template);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateTemplate(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_TEMPLATE],
    payload: {
      promise: patchTemplate(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, template);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeTemplate(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_TEMPLATE],
    payload: {
      promise: deleteTemplate(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getTemplateSections(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_TEMPLATE_SECTIONS],
    payload: {
      promise: getTemplateSectionsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(section));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid: uid
    }
  });
}

export function createTemplateSection(data, uid) {
  data.columnNumber = 1;
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_TEMPLATE_SECTIONS],
    payload: {
      promise: validateForm
        ["createTemplateSection"](validate, data)
        .then(() =>
          postTemplateSections(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, section);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsAddTemplateModalVisible(value) {
  return {
    type: SET_IS_ADD_TEMPLATE_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsAddSectionModalVisible(value) {
  return {
    type: SET_IS_ADD_SECTION_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsEditTemplateModalVisible(value) {
  return {
    type: SET_IS_EDIT_TEMPLATE_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsRemoveTemplateModalVisible(value) {
  return {
    type: SET_IS_REMOVE_TEMPLATE_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

// Standard functions
export function validateFormFieldTemplates(form, name, value) {
  const feature = "templates";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/templates/actions.js